/**
 * This page is solely for displaying "Berhta" under the Flash DC website.
 * It is meant to be temporary!
 */
import Head from 'next/head';
import type { GetStaticPaths, GetStaticProps } from 'next';

import EventListing from '@/components/eventListing/eventListing';
import Layout from '@/components/layout';
import SiteContextProvider from '@/contexts/siteContext';
import { getEventsBySite, getSingleSiteData } from '@/lib/fetchers/sites';
import { DEFAULT_REVALIDATE_TIME } from '@/constants';
import type { Event, Site, SitePageProps, SiteParams } from '@/types';

interface BerhtaPageProps extends SitePageProps {
  events: Event[];
  berhta: Site;
}

export const getStaticPaths: GetStaticPaths<SiteParams> = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<
  SitePageProps,
  SiteParams
> = async ({ params }) => {
  const [site, flashEvents] = await Promise.all([
    getSingleSiteData(params?.site),
    getEventsBySite(params?.site),
  ]);

  if (site.url_name !== 'flashdc') {
    return {
      notFound: true,
    };
  }

  const berhta = await getSingleSiteData('berhta');
  const events = flashEvents.filter(({ brand }) => brand === 'UUbs89E8gw');

  return {
    props: { events, site, berhta },
    revalidate: Number.parseInt(
      process.env.ISR_REVALIDATE_TIME || DEFAULT_REVALIDATE_TIME,
    ),
  };
};

const BerhtaPage = ({ events, site, berhta }: BerhtaPageProps) => {
  return (
    <SiteContextProvider site={site}>
      <Head>
        <title key="title">Sunday Love at Flash</title>
      </Head>
      <Layout>
        {berhta.html_about && (
          <div dangerouslySetInnerHTML={{ __html: berhta.html_about }} />
        )}
        <h2 className="border-bottom border-gray mb-5 pb-3">Events</h2>
        {events.map((event) => (
          <EventListing event={event} key={event.name} />
        ))}
      </Layout>
    </SiteContextProvider>
  );
};

export default BerhtaPage;
